import { ReactNode } from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import Text from '../typography/v2/text';

type ToolTipProps = {
  children: ReactNode;
  extensions?: string;
  text: string;
};

export default function ToolTipWrapper(props: ToolTipProps) {
  const { extensions } = props;
  return (
    <Tooltip.Root delayDuration={1000}>
      <Tooltip.Trigger className={extensions && extensions}>
        {props.children}
      </Tooltip.Trigger>
      <Tooltip.Content className="bg-primary  px-2.5 pb-1 rounded">
        <Tooltip.Arrow fill="#FBFCF4" className="m-0 p-0" />
        <Text variant="tooltip" color="neutral">
          {props.text}
        </Text>
      </Tooltip.Content>
    </Tooltip.Root>
  );
}
